import ContentContainer from "Components/Container/ContentContainer";
import { Button, Description, SubTitle } from "Components/CustomComponents";
import styles from "../styles/Driver.module.scss";
import { Drivers } from "Data/interfaces";

interface DriverProfileCardProps {
  driver: Drivers;
}

const DriverProfileCard: React.FC<DriverProfileCardProps> = ({ driver }) => {
  //   console.log(driver);
  return (
    <ContentContainer
      bg="#efefef"
      hasBoxShadow={false}
      classes="p-4"
      style={{ borderRadius: "16px", minWidth: "206px" }}
    >
      <div className="d-flex gap-2 mb-4">
        <img alt="" src={driver.image_url} className={styles.image} />
        <div className={`d-flex flex-column`}>
          <SubTitle text={driver.username} classes="mb-05 lc-1" />
          <Description
            text={
              <>
                Truck No:
                <span className="fw-bold ms-2">{driver.truck_no}</span>
              </>
            }
          />
        </div>
      </div>

      <Button text="View Details" isOutlined={true} classes={` fs-7`} />
    </ContentContainer>
  );
};

export default DriverProfileCard;
